module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZFgPY9/image/1.png",
      "alt": "This image is the cover for the book Frazzel McDoo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Frazzel McDoo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("This book ")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("about a dog who has one shoe and no laces.")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("He raids the fridge. He chases the cat. He goes under the child's bed looking for shoes.")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("He swims in the fish tank and gets a lace that works for the child")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("’s")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" father")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("’")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("s shoe. ")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("And then he")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" leaves. ")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sean Scott Collins\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Sean Scott Collins was born and raised in Vermont. After college, Sean joined the army for 8 years. Then he moved to Cincinnati as a Cable TV Tech. He is now semi-retired in Vermont.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1291cb2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0